import { useCallback, useSyncExternalStore } from 'react';
import type { WorkspaceTab } from '../prompt/executor';

export type Route = { name: 'dashboard' } | { name: 'project'; projectId: string; tab: WorkspaceTab };

export const TABS: readonly WorkspaceTab[] = ['music', 'animation', 'sync', 'visualizer', 'audio', 'assistant', 'settings'];

export function parseHash(hash: string): Route {
  const m = hash.match(/^#\/project\/([A-Za-z0-9_-]+)(?:\/([a-z]+))?$/);
  if (m) {
    const tab = (TABS as readonly string[]).includes(m[2] ?? '') ? (m[2] as WorkspaceTab) : 'music';
    return { name: 'project', projectId: m[1]!, tab };
  }
  return { name: 'dashboard' };
}

export function routeToHash(route: Route): string {
  return route.name === 'dashboard' ? '#/' : `#/project/${route.projectId}/${route.tab}`;
}

const subscribe = (cb: () => void) => {
  window.addEventListener('hashchange', cb);
  return () => window.removeEventListener('hashchange', cb);
};
const getHash = () => window.location.hash;

/** Tiny hash router: routes survive refreshes and need no server configuration. */
export function useRoute(): [Route, (route: Route) => void] {
  const hash = useSyncExternalStore(subscribe, getHash, () => '');
  const navigate = useCallback((route: Route) => {
    const next = routeToHash(route);
    if (window.location.hash !== next) window.location.hash = next;
  }, []);
  return [parseHash(hash), navigate];
}
